import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-create-hyperreplication",
  "use": "app-icon-create-hyperreplication-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-icon-create-hyperreplication\"><g stroke=\"#6C92FA\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1 8h23v23H1z\" /><path d=\"M11 1h20v20\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol